import { BufferGeometry } from 'three';

export interface MeshDTO {
  indices: number[];
  positions: number[];
}

export function bufferGeometryToMeshDTO(geometry: BufferGeometry): MeshDTO {
  return {
    indices: Array.from(geometry.index!.array),
    positions: Array.from(geometry.attributes.position.array),
  };
}
